import {Ticket} from "../booking/ticket";
export class BookingList {
  public Pricing_label:string;
  public tickets:Ticket[];
  constructor() {}
}
